"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentTypes = exports.PaymentDataApiCheckStatus = exports.PaymentStatus = void 0;

var common_1 = require("./common");

var PaymentStatus;

(function (PaymentStatus) {
  PaymentStatus["DRAFT"] = "draft";
  PaymentStatus["SENT"] = "sent";
  PaymentStatus["PENDING"] = "pending";
  PaymentStatus["OVERDUE"] = "overdue";
  PaymentStatus["PAID"] = "paid";
  PaymentStatus["REJECTED"] = "rejected";
  PaymentStatus["CANCELLED"] = "cancelled";
  PaymentStatus["REFUND_STARTED"] = "refund_started";
  PaymentStatus["REFUND_REJECTED"] = "refund_rejected";
  PaymentStatus["REFUNDED"] = "refunded";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));

var PaymentDataApiCheckStatus;

(function (PaymentDataApiCheckStatus) {
  PaymentDataApiCheckStatus["PENDING_PAYMENT"] = "pending_payment";
  PaymentDataApiCheckStatus["MISSED_PAYMENT"] = "missed_payment";
  PaymentDataApiCheckStatus["PAYMENT_MADE"] = "payment_made";
  PaymentDataApiCheckStatus["PARTIAL_PAYMENT"] = "partial_payment";
  PaymentDataApiCheckStatus["UNABLE_TO_CHECK"] = "unable_to_check";
  PaymentDataApiCheckStatus["PERMANENT_CONNECTION_LOSS"] = "permanent_connection_loss";
  PaymentDataApiCheckStatus["WAITING_FOR_FIRST_CHECK"] = "waiting_for_first_check";
})(PaymentDataApiCheckStatus = exports.PaymentDataApiCheckStatus || (exports.PaymentDataApiCheckStatus = {}));

var PaymentTypes;

(function (PaymentTypes) {
  PaymentTypes["LINK"] = "link";
  PaymentTypes["QR"] = "qr";
  PaymentTypes["MOBILE"] = "mobile";
  PaymentTypes["EXTERNAL"] = "external";
  PaymentTypes["RECURRING_INITIAL"] = "recurring_initial";
})(PaymentTypes = exports.PaymentTypes || (exports.PaymentTypes = {}));